import { message } from "antd"
import { HttpClient } from "~/api/HttpClient"
import { t } from "~/languages/i18n"
import { FilterSearchParams } from "~/types/types"

export const API_PREFIX_PARENT_QUESTION_PATH = "/api/parent-questions"

export const fetchParentQuestions = async (searchTerms: { [key: string]: string } = {}) => {
  const params: FilterSearchParams = {
    populate: "*",
    sort: "createdAt:desc",
    filters: {},
    pagination: {
      page: "1",
      pageSize: "100",
    },
  }

  const excludedKeys = ["current", "pageSize", "start", "limit", "total", "page"]

  Object.keys(searchTerms).forEach(key => {
    const value = searchTerms[key]

    if (key === "status") {
      if (value && value !== "all") {
        params.filters.status = { $eq: value }
      }
    } else if (!excludedKeys.includes(key)) {
      if (value) {
        params.filters[key] = { $containsi: value }
      }
    } else if (value) {
      params.pagination = {
        ...params.pagination,
        [key]: value,
      }
    }
  })

  try {
    const response = await HttpClient.get(`${API_PREFIX_PARENT_QUESTION_PATH}`, { params })
    return {
      data: response.data,
      meta: response.meta,
    }
  } catch (error) {
    message.error(t("Failed to fetch Parent Questions"))
  }
}

export const fetchParentQuestionStats = async () => {
  try {
    const response = await HttpClient.get(`${API_PREFIX_PARENT_QUESTION_PATH}/stats`)
    return response.data
  } catch (error) {
    message.error(t("Failed to fetch Parent Question Stats"))
  }
}

export const fetchParentQuestionById = async (id: number) => {
  try {
    const response = await HttpClient.get(`${API_PREFIX_PARENT_QUESTION_PATH}/${id}?populate=*`)
    return response.data
  } catch (error) {
    message.error(t("Failed to fetch Parent Question"))
    throw error
  }
}

export const createParentQuestion = async (data: any) => {
  try {
    const response = await HttpClient.post(`${API_PREFIX_PARENT_QUESTION_PATH}`, { data })
    return response.data
  } catch (error) {
    message.error("Không thể tạo Parent Question. Vui lòng thử lại.")
    throw error
  }
}

export const updateParentQuestion = async (id: number, data: any) => {
  try {
    const response = await HttpClient.put(`${API_PREFIX_PARENT_QUESTION_PATH}/${id}`, { data })
    return response.data
  } catch (error) {
    message.error(t("Failed to update Parent Question"))
    throw error
  }
}

export const deleteParentQuestion = async (id: number) => {
  try {
    await HttpClient.delete(`${API_PREFIX_PARENT_QUESTION_PATH}/${id}`)
  } catch (error) {
    message.error(t("Failed to delete Parent Question"))
    throw error
  }
}
